import type { User } from "firebase/auth";
import type { CommunityProfile, RoadmapResponse, SuggestionInput } from "../types";

const API_BASE = (import.meta.env.VITE_COMMUNITY_API_URL || "https://community-api.mashr.ai").replace(/\/$/, "");

async function request<T>(path: string, user?: User | null, init: RequestInit = {}): Promise<T> {
  const token = user ? await user.getIdToken() : undefined;
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      Accept: "application/json",
      ...(init.body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init.headers
    }
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({})) as { error?: string };
    throw new Error(payload.error || `Community request failed (${response.status}).`);
  }
  return response.status === 204 ? undefined as T : response.json() as Promise<T>;
}

export const communityApi = {
  roadmap: (user?: User | null) => request<RoadmapResponse>("/v1/products/blockr/roadmap", user),
  me: (user: User) => request<CommunityProfile>("/v1/me", user),
  vote: (user: User, issueNumber: number, voted: boolean) =>
    request<{ voted: boolean; verifiedVoteCount: number }>(`/v1/products/blockr/items/${issueNumber}/vote`, user, {
      method: voted ? "PUT" : "DELETE"
    }),
  suggest: (user: User, suggestion: SuggestionInput) =>
    request<{ suggestionId: string }>("/v1/products/blockr/suggestions", user, {
      method: "POST",
      body: JSON.stringify(suggestion)
    })
};
